import { render, staticRenderFns } from "./SetUpMyReport.vue?vue&type=template&id=9661ef32&"
import script from "./SetUpMyReport.vue?vue&type=script&lang=js&"
export * from "./SetUpMyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports